<template>
  <div v-if="showBanner" class="cookiebanner-container">
    <div>
      <h3>Wij gebruiken cookies</h3>
      <p>We gebruiken analytische cookies om inzicht te krijgen in hoe onze applicatie wordt gebruikt. Deze informatie helpt ons om functies te verbeteren, problemen sneller op te lossen en de gebruikservaring te optimaliseren.</p>
      <p>Daarnaast stellen we geanonimiseerde gebruiksstatistieken beschikbaar aan de organisatie die deze omgeving beheert, zodat zij inzicht krijgen in het gebruik van de applicatie binnen hun eigen organisatie.</p>
      <p>Je kunt zelf kiezen of je analytische cookies wilt toestaan. Als je deze weigert, blijven alle noodzakelijke functies van de applicatie gewoon werken.</p>
    </div>
    <div class="cookiebanner-controls">
      <button @click="rejectCookies" class="input-button">Weigeren</button>
      <button @click="acceptCookies" class="input-button input-button-primary">Accepteren</button>
    </div>
  </div>
</template>

<script>
import Roles from '@/constants/roles'

export default {
  name: 'cookiebanner',
  data: () => ({
    bannerEnabled: true
  }),
  computed: {
    showBanner () {
      return this.bannerEnabled && (this.$posthog.get_explicit_consent_status() === 'pending')
    }
  },
  methods: {
    acceptCookies () {
      this.$posthog.opt_in_capturing()

      const role = this.$store.getters.getRole
      if (role !== Roles.ANONYMOUS) {
        const user = this.$store.getters.getSession?.user
        if (user) {
          let name = user.name.first
          if (user.name.middle) name += ` ${user.name.middle}`
          name += ` ${user.name.last}`

          this.$posthog.identify(user.id, {
            name: name,
            email: user.email
          })
        }
      }

      this.bannerEnabled = false
    },
    rejectCookies () {
      this.$posthog.opt_out_capturing()
      this.bannerEnabled = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .cookiebanner-container {
    display: block;
    position: fixed;
    bottom: 10px;
    width: 60%;
    left: 20%;
    background: white;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.4);
    padding: 20px;
    border-radius: 4px;
    overflow: hidden;
  }

  .cookiebanner-controls {
    text-align: right;
  }
</style>
